module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/phand23-b146c55ad295212e02ee5224d20035b6.jpg";